// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir=ltr] .infoIcon--wneX0 {
  margin-left: 5px;
}[dir=rtl] .infoIcon--wneX0 {
  margin-right: 5px;
}

.measureGrid--dSgbT {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}

[dir] .measureGrid--dSgbT {
  margin-top: 20px;
}

.measureTrend--kMovE,
.measureRank--UwF2Z {
  flex: 1 1 0;
  min-width: 0;
  box-sizing: border-box;
}

[dir] .measureTrend--kMovE, [dir] .measureRank--UwF2Z {
  padding: 0 10px;
}

[dir=ltr] .measureTrend--kMovE {
  padding-right: 0;
}

[dir=rtl] .measureTrend--kMovE {
  padding-left: 0;
}

[dir=ltr] .measureRank--UwF2Z {
  border-left: 1px solid #d8d8d8;
  padding-left: 0;
}

[dir=rtl] .measureRank--UwF2Z {
  border-right: 1px solid #d8d8d8;
  padding-right: 0;
}

/* Hide border when ranking is hidden */
.measureRank--UwF2Z.uk-hidden--CPKM5 {
  display: none;
}

/* When ranking is hidden or not present, trend takes full width */
.measureGrid--dSgbT:has(.measureRank--UwF2Z.uk-hidden--CPKM5) .measureTrend--kMovE,
.measureGrid--dSgbT:not(:has(.measureRank--UwF2Z)) .measureTrend--kMovE {
  flex: 1 1 100%;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OverviewSubjectSummary/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB,CAFA;EACE,iBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAE9B,SAAS;EACT,WAAW;AACb;;AAPA;EAIE,gBAAgB;AAGlB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;AAExB;;AANA;EAKE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,eAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAHA;EACE,+BAA8B;EAC9B,gBAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,kEAAkE;AAClE;;EAEE,cAAc;AAChB","sourcesContent":[".infoIcon {\n  margin-left: 5px;\n}\n\n.measureGrid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 20px;\n  gap: 10px;\n  width: 100%;\n}\n\n.measureTrend,\n.measureRank {\n  flex: 1 1 0;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 0 10px;\n}\n\n.measureTrend {\n  padding-right: 0;\n}\n\n.measureRank {\n  border-left: 1px solid #d8d8d8;\n  padding-left: 0;\n}\n\n/* Hide border when ranking is hidden */\n.measureRank.uk-hidden {\n  display: none;\n}\n\n/* When ranking is hidden or not present, trend takes full width */\n.measureGrid:has(.measureRank.uk-hidden) .measureTrend,\n.measureGrid:not(:has(.measureRank)) .measureTrend {\n  flex: 1 1 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoIcon": `infoIcon--wneX0`,
	"measureGrid": `measureGrid--dSgbT`,
	"measureTrend": `measureTrend--kMovE`,
	"measureRank": `measureRank--UwF2Z`,
	"uk-hidden": `uk-hidden--CPKM5`
};
export default ___CSS_LOADER_EXPORT___;
